import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { fontRobotoCondensed, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

export const SectionTitle = styled.div`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const StyledSwiper = styled(Swiper)`
  inline-size: 100%;

  touch-action: pan-y;

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    inline-size: 153px;
  }

  ${theme.breakpoints.up("tablet")} {
    &.swiper-slide {
      inline-size: 125px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    &.swiper-slide {
      inline-size: 156px;
    }
  }
`;
